<template>
  <div>
    <div class="d-flex mb-3">
      <h1 class="h4 primary--text">
        {{ $t('views.shipment_notice_edit.shipment_notice_edit') }}
      </h1>
      <div class="ml-auto d-flex">
        <router-link
          to="/asn"
          class="shipment-notice__back-link my-auto"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
          >
            <path
              d="M9,4l.881.881L6.394,8.375H14v1.25H6.394l3.487,3.494L9,14,4,9Z"
              transform="translate(-4 -4)"
            />
          </svg>
          {{ $t('views.shipment_notice_edit.back_to_list') }}
        </router-link>
      </div>
    </div>
    <app-loader v-if="loading" />
    <shipment-notice-form
      v-else
      :initial-asn="asn"
      :saving="saving"
      @save="save"
    />
    <shipment-notice-errors-modal
      v-model="isErrorsModalShown"
      :error-list="errorsModalList"
      :title="$t('views.shipment_notice_edit.validation_errors')"
    />
  </div>
</template>

<script>
import ShipmentNoticeForm from '@/components/asn/ShipmentNoticeForm.vue';
import ShipmentNoticeErrorsModal from '@/components/asn/ShipmentNoticeErrorsModal.vue';
import AppLoader from '@/components/common/AppLoader.vue';

export default {
  name: 'ShipmentNoticeEdit',

  components: {
    ShipmentNoticeForm,
    ShipmentNoticeErrorsModal,
    AppLoader,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      asn: {},
      loading: false,
      saving: false,

      isErrorsModalShown: false,
      errorsModalList: [],
    };
  },

  created() {
    this.getAsn();
  },

  methods: {
    async getAsn() {
      this.loading = true;
      try {
        const { data = {} } = await this.$http.get(`/asn/${this.id}`);
        this.asn = data;
      } catch (error) {
        if (error.response && (error.response.status === 404 || error.response.status === 403)) {
          this.$router.push('/asn');
        } else {
          this.$http.mockApiError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async save(asn) {
      this.saving = true;
      try {
        await this.$http.put(`/asn/${this.id}`, asn);
        this.$router.push('/asn');
      } catch (error) {
        if (error.translatedErrorList) {
          this.errorsModalList = error.translatedErrorList;
          this.isErrorsModalShown = true;
        } else {
          this.$toast(this.$t('views.shipment_notice_edit.validation_errors'), {
            title: this.$t('toast.danger'),
            variant: 'danger',
          });
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-notice__back-link {
  text-decoration: none;
  transition: color 0.3s ease-in-out 0s;

  svg {
    fill: #ad7c59;
    margin-right: 5px;
    transition: fill 0.3s ease-in-out 0s;
  }

  &:hover {
    color: var(--margaritas);

    svg {
      fill: var(--margaritas);
    }
  }
}
</style>
